import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          // Reserve right-side padding for the inline close button so the
          // text never sits underneath it.
          toast:
            "group/toast pointer-events-auto shadow-lg border ring-1 ring-black/5 dark:ring-white/5 !pr-10",
          title: "text-sm font-medium",
          description: "text-xs opacity-90",
          actionButton:
            "bg-foreground text-background hover:bg-foreground/90",
          cancelButton:
            "bg-muted text-muted-foreground hover:bg-muted/80",
          // Move the close button INSIDE the toast on the right, replacing
          // Sonner's default floating-circle-on-top-left look.
          closeButton:
            "!opacity-60 hover:!opacity-100 !left-auto !right-2 !top-1/2 !-translate-y-1/2 !translate-x-0 !size-6 !rounded-md !border-0 !bg-transparent hover:!bg-foreground/10 !text-current transition-opacity",
        },
        // Errors stay longer — users may need to read or copy them.
        duration: 5000,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
          // Bump default toast width slightly for better readability
          "--width": "380px",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
